import * as React from "react"

export const MOBILE_BREAKPOINT = 768
export const DRAWER_BREAKPOINT = 1024
export const isMobileViewport = (width: number) => width < MOBILE_BREAKPOINT
export const isDrawerViewport = (width: number) => width <= DRAWER_BREAKPOINT

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(() => {
    if (typeof window !== "undefined") {
      return isMobileViewport(window.innerWidth);
    }
    return undefined;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(isMobileViewport(window.innerWidth))
    }
    mql.addEventListener("change", onChange)
    setIsMobile(isMobileViewport(window.innerWidth))
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

export function useIsDrawerViewport() {
  const [isDrawer, setIsDrawer] = React.useState<boolean | undefined>(() => {
    if (typeof window !== "undefined") return isDrawerViewport(window.innerWidth);
    return undefined;
  });

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${DRAWER_BREAKPOINT}px)`);
    const onChange = () => setIsDrawer(isDrawerViewport(window.innerWidth));
    mql.addEventListener("change", onChange);
    setIsDrawer(isDrawerViewport(window.innerWidth));
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isDrawer;
}
